
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sobre",
      function () {
        return require("private-next-pages/sobre/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sobre"])
      });
    }
  